import { Card, Grid, TextField } from "@mui/material";
import WDBox from "../../../../MaterialComponents/WDBox";
import WDButton from "../../../../MaterialComponents/WDButton";
import WDTypography from "../../../../MaterialComponents/WDTypography";
import AppService from "../../../../Configurations/Appservice";

import { Formik, Form, Field } from "formik";
import { object, string } from "yup";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import {
  dismissLoader,
  showLoader,
  showSuccessMessage,
  updateScreenTitle,
} from "../../../../LayoutContainers/AppLayout/redux/AppSlice";
import DataTable from "../../../../Components/Table/DataTable";

const initialValues = {
  name: "",
};

const validationSchema = object({
  name: string().trim().required("Name is Mandatory"),
});

const tableInitialData = {
  columns: [
    { Header: "Payment Mode", accessor: "name", width: "60%" },
  ],
  rows: [],
};

const PaymentMethod = () => {
  const dispatch = useDispatch();
  const [tableData, setTableData] = useState(tableInitialData);

  useEffect(() => {
    dispatch(updateScreenTitle("Payment Mode"));
    return () => dispatch(updateScreenTitle(""));
  });

  const _onSubmit = (values, { resetForm }) => {
    dispatch(showLoader());
    AppService.post("v1/paymentMethod", values)
      .then((response) => {
        resetForm();
        dispatch(showSuccessMessage());
        // Refresh the table (if types reflect newly added modes)
        _loadPaymentTypes();
      })
      .catch((error) => {})
      .finally(() => {
        dispatch(dismissLoader());
      });
  };

  const _loadPaymentTypes = async () => {
    try {
      const resp = await AppService.get("v1/wallet/paymentTypes");
      const items = Array.isArray(resp) ? resp : resp?.data || [];
      setTableData((prev) => ({
        ...prev,
        rows: items.map((it) => ({ name: it?.name || it?.label || it?.text || "" })),
      }));
    } catch (e) {
      // ignore
    }
  };

  useEffect(() => {
    _loadPaymentTypes();
  }, []);

  return (
    <WDBox py={1}>
      <Card sx={{ padding: 3 }}>
        <Formik
          initialValues={initialValues}
          onSubmit={_onSubmit}
          validationSchema={validationSchema}
        >
          {({ errors, isValid, touched, dirty }) => (
            <Form>
              <WDBox>
                <WDTypography fontSize={14}>New Payment Mode</WDTypography>
              </WDBox>
              <WDBox my={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <Field
                        name="name"
                        label="Name"
                        fullWidth
                        as={TextField}
                        error={Boolean(errors.name) && Boolean(touched.name)}
                        helperText={Boolean(touched.name) && errors.name}
                      />
                    </WDBox>
                  </Grid>
                </Grid>
              </WDBox>
              <WDBox display="flex" justifyContent="flex-end" pt={3}>
                <WDButton variant="gradient" disabled={!dirty || !isValid} type="submit">
                  Submit
                </WDButton>
              </WDBox>
            </Form>
          )}
        </Formik>
      </Card>
      {/* Wallet Payment Types */}
      <WDBox mt={2}>
        <Card sx={{ p: 2 }}>
          <DataTable table={tableData} showAddButton={false} />
        </Card>
      </WDBox>
    </WDBox>
  );
};

export default PaymentMethod;
